import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white text-center py-8">
      <p className="mb-4">&copy; {new Date().getFullYear()} Vivat Alfa Winery. All rights reserved.</p>
      <div className="flex justify-center space-x-6">
        <a
          href="https://instagram.com/vivatalfa_winery"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Vivat Alfa Winery on Instagram"
          className="text-gold hover:text-white transition"
        >
          <Instagram />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61570319830153"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Vivat Alfa Winery on Facebook"
          className="text-gold hover:text-white transition"
        >
          <Facebook />
        </a>
      </div>

      <p className="text-sm text-gray-400 mt-6">
        <a href="/privacy" className="hover:text-white transition underline">Privacy Policy</a>
        <span className="mx-3" aria-hidden="true">·</span>
        Please enjoy our wines responsibly.
      </p>
    </footer>
  );
}

export default Footer;
